import LocalLoader from './LocalLoader';

export default LocalLoader;
